<div class="row d-flex align-items-center mx-0">
    <div class="col-6 pt-4">
        <img src="assets/images/IRR-Logo3.svg" class="placeholder-irr-logo">

    </div>
    <div class="col-6 text-right pt-4">
        <img src="assets/images/EY-Logo-White.png" class="placeholder-ey-logo">
    </div>
</div>
<div class="row mx-0">
    <div class="col-12 text-center">
        <h1 class="loading-app-name"> <b>I</b>ntegrated <b>R</b>egulatory <b>R</b>eporting</h1>
    </div>
</div>
<div class="row mx-0 d-flex align-items-center justify-content-center text-center">
    <div class="col-md-8 error-code">
        <img src="assets/images/logout.svg" class="logout-img mt-5">
        
    </div>
    <div class="col-md-12 text-white mt-5">
        <h3>Log Out</h3>
        <h5>You have logged out of the application, please use the below link to login</h5>
        <button class="btn btn-secondary-ey btn-icon small-font hvr-shrink mt-4" type="button" (click)="goBack()">
            <div class="icon-container"><i class="fas fa-sign-in-alt fa-lg"></i></div><span>Login</span>
        </button>
    </div>
</div>